import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api, { apiErr } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { BRANDING } from "@/config/branding";

export default function PasswordRecovery({ reset = false }) {
  const [token] = useState(() => new URLSearchParams(window.location.hash.slice(1)).get("token") || "");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [confirmation, setConfirmation] = useState("");
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");
  const [message, setMessage] = useState("");
  useEffect(() => {
    if (reset && window.location.hash) window.history.replaceState(null, "", window.location.pathname);
  }, [reset]);
  const submit = async (e) => {
    e.preventDefault();
    if (reset && password !== confirmation) { setError("Le password non coincidono."); return; }
    setBusy(true); setError("");
    try {
      const { data } = await api.post(reset ? "/auth/reset-password" : "/auth/forgot-password",
        reset ? { token, new_password: password } : { email });
      setMessage(reset ? "Password aggiornata. Tutte le sessioni precedenti sono state revocate: accedi con la nuova password." : data.message);
      setPassword(""); setConfirmation("");
    } catch (err) { setError(apiErr(err)); }
    finally { setBusy(false); }
  };
  return <main className="min-h-screen bg-background px-5 py-10 flex items-center justify-center">
    <div className="w-full max-w-md space-y-6">
      <img src={BRANDING.logo} alt="K9 Manager" className="h-16 w-16 rounded-2xl" />
      <h1 className="font-head text-2xl font-bold">{reset ? "Imposta una nuova password" : "Recupera la password"}</h1>
      {message ? <p role="status" className="rounded-xl border p-4">{message}</p> : reset && !token ?
        <p role="alert">Link assente o non valido. <Link to="/forgot-password" className="underline">Richiedi un nuovo reset</Link>.</p> :
        <form onSubmit={submit} className="space-y-4">
          {reset ? <>
            <p className="text-sm text-muted-foreground">Scegli una password diversa dalla precedente, di almeno 8 caratteri.</p>
            <div><Label htmlFor="new-password">Nuova password</Label><Input id="new-password" type="password" autoComplete="new-password" required minLength={8} maxLength={72} value={password} onChange={e => setPassword(e.target.value)} className="h-12" /></div>
            <div><Label htmlFor="confirm-password">Conferma password</Label><Input id="confirm-password" type="password" autoComplete="new-password" required value={confirmation} onChange={e => setConfirmation(e.target.value)} className="h-12" /></div>
          </> : <div><Label htmlFor="recovery-email">Email del tuo account</Label><Input id="recovery-email" type="email" autoComplete="email" required maxLength={254} value={email} onChange={e => setEmail(e.target.value)} className="h-12" /></div>}
          {error && <p role="alert" className="text-destructive text-sm">{error}</p>}
          <Button type="submit" disabled={busy} className="w-full h-12">{busy ? "Attendi…" : reset ? "Salva nuova password" : "Invia istruzioni"}</Button>
          {reset && <Link to="/forgot-password" className="block text-sm underline">Richiedi un nuovo link</Link>}
        </form>}
      <a href="/login" className="block underline">Torna al login</a>
    </div>
  </main>;
}
